export default __webpack_public_path__ + "static/media/150x150_01.91104fc2.jpg";